import gql from "graphql-tag";


export const HOTEL_FRAGMENT = gql`
    fragment HotelFragment on Hotel{
        type
        name
        propertyId
        propertyType
        city
        country
        hotelRating
        address
        location {
            lat
            lon
        }
        rooms {
            type
            roomCode
            description
            price
            total
            maxRoomCapacity
        }
    }
`;